import { render, staticRenderFns } from "./title-zhu.vue?vue&type=template&id=17e9f70e&scoped=true&"
import script from "./title-zhu.vue?vue&type=script&lang=ts&"
export * from "./title-zhu.vue?vue&type=script&lang=ts&"
import style0 from "./title-zhu.vue?vue&type=style&index=0&id=17e9f70e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e9f70e",
  null
  
)

export default component.exports